import { useState } from "react";
import {
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { connect } from "react-redux";
import moment from "moment";
import CustomizedLetter from "../../documents/LetterFormat/CustomizedLetter";
import InstitutionDetails from "../../training/components/InstitutionDetails";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";

const ViewLeaveLetter = (props) => {
  const {
    setShowLeaveLetter,
    showLeaveLetter,
    leaveRequest,
    selectedFiscalYear,
    signCallBack,
  } = props;

  const [letterFooterContentErrors, setLetterFooterContentErrors] = useState(
    []
  );
  const [showErrors, setShowErrors] = useState(false);

  const onClose = () => {
    setShowLeaveLetter(false);
  };

  const handleLoadFooterContent = (data) => {
    let errors = [];
    if (!data?.entity?.acronym) {
      errors = [...errors, "The institution acronym is missing!"];
    }

    if (!!data && !data?.entity?.institutionPhone) {
      errors = [
        ...errors,
        "The institution phone number is required. Please update it",
      ];
    }

    if (data?.entity?.institutionPhone?.includes("+25078XXXXXXX")) {
      errors = [
        ...errors,
        `The institution phone number (${data?.entity?.institutionPhone || ""
        }) does not seem correct. Please update it.`,
      ];
    }

    if (!!data && !data?.entity?.institutionEmail) {
      errors = [
        ...errors,
        "The institution email is required. Please update it",
      ];
    }

    if (data?.entity?.institutionEmail?.includes("example")) {
      errors = [
        ...errors,
        `The institution email (${data?.entity?.institutionEmail || ""
        }) does not seem correct. Please update it.`,
      ];
    }

    if (!!data && !data?.entity?.poBox) {
      errors = [
        ...errors,
        "The institution PO.Box is required. Please update it",
      ];
    }

    if (!!data && !data?.entity?.websiteUrl) {
      errors = [
        ...errors,
        "The institution website url is required. Please update it",
      ];
    }
    if (!!data && !data?.entity?.twitterPage) {
      errors = [
        ...errors,
        "The institution former(twitter) is required. Please update it",
      ];
    }
    setLetterFooterContentErrors(errors);
    setShowErrors(!!errors.length);
  };

  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showLeaveLetter}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle className="text-dark pb-2 ">
          <Typography
            variant="overline"
            className="text-truncate"
            display="block"
            style={{ maxWidth: "90%" }}
          >
            {leaveRequest.leaveType}
            <strong className="text-primary ml-2">
              {selectedFiscalYear?.name}
            </strong>
          </Typography>

          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
        </DialogTitle>

        <DialogContent className="py-1">
          <CustomizedLetter
            disableToEditLetterHeader={true}
            enableToFillLetter={false}
            signContent={
              <>
                <InstitutionDetails
                  headOfInstitution={{
                    isDelegated: false,
                    isMinster: leaveRequest.isMinster,
                    firstName: leaveRequest?.supervisorFirstNames,
                    lastName: leaveRequest?.supervisorLastNames,
                    institutionName: leaveRequest.supervisorEntityName,
                    positionName: leaveRequest.supervisorPositionName,
                    canAddInstitutionName: false,
                  }}
                  userSignature={null}
                />
              </>
            }
            subTitle={null}
            entitySectorId={leaveRequest.entitySectorId}
            planningEntityId={leaveRequest.planningEntityId}
            letterBodyContent={`
<p>
  ${leaveRequest?.letterContent ?? `Pursuant to the Law No.017/2020 of 07/10/2020 establishing the
  general statute governing public servants, especially in its
  article 18, 19 and 20 relating to annual leave ;`}
</p>
<p>Basing on the request of Ms/Mr.:</p>
<p>Names: ${leaveRequest.employeeNames}</p>
<p>Department/ Unit :${leaveRequest.unitName}</p>
<p>Position:${leaveRequest.positionName}</p>
${!!leaveRequest.leaveReason
                ? `<p>Reason:${leaveRequest.leaveReason}</p>`
                : ""
              }
<p>
${leaveRequest.leaveType} of ${leaveRequest.numberOfDays || leaveRequest.numOfDays
              } ${(leaveRequest.numberOfDays || leaveRequest.numOfDays) === 1
                ? `day on ${moment(leaveRequest.startDate).format("LL")}`
                : `days from ${moment(leaveRequest.startDate).format(
                  "LL"
                )} to ${moment(leaveRequest.endDate).format("LL")}`
              } in the fiscal year of ${selectedFiscalYear?.name
              } is granted to Ms/Mr. ${leaveRequest.employeeNames}.
</p>`}
            title={leaveRequest.leaveType}
            titlePosition="center"
            loadFooterContent={(data) => handleLoadFooterContent(data)}
          />
        </DialogContent>
        <DialogActions className="d-flex justify-content-center py-4">
          {!letterFooterContentErrors.length ? (
            signCallBack
          ) : (
            <Chip
              label="Show Letter Warnings"
              onDelete={() => setShowErrors(true)}
              deleteIcon={<VisibilityRoundedIcon />}
              variant="outlined"
              color="error"
            />
          )}
        </DialogActions>
      </Dialog>

      <Dialog
        onClose={() => setShowErrors(false)}
        aria-labelledby="letter-warnings"
        open={!!showLeaveLetter && !!showErrors}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle className="text-dark pb-2">
          <Typography
            variant="overline"
            className="text-truncate"
            display="block"
            style={{ maxWidth: "90%" }}
          >
            <strong className="text-danger mr-2">Warnings:</strong>
            Leave Customization
          </Typography>

          <IconButton
            aria-label="close"
            onClick={() => setShowErrors(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
        </DialogTitle>

        <DialogContent className="py-1">
          <div className="alert alert-warning" role="alert">
            <h2 className="alert-heading">Warnings:</h2>
            <ul className="mb-0">
              {letterFooterContentErrors.map((error, index) => (
                <li key={index} className="text-sm">
                  {error}
                </li>
              ))}
            </ul>

            <p className="alert alert-info font-weight-bold mt-3">
              Please contact HR to fill all those information!
            </p>
          </div>
        </DialogContent>
        <DialogActions className="d-flex justify-content-center py-4"></DialogActions>
      </Dialog>
    </>
  );
};

const mapStateToProps = ({ loading, selectedFiscalYear }) => {
  return {
    loading,
    selectedFiscalYear,
  };
};
export default connect(mapStateToProps, {})(ViewLeaveLetter);
